import { Component } from '@angular/core';

@Component({
  selector: 'ngx-carrier-methods',
  templateUrl: './carrier-methods.component.html',
  styleUrls: ['./carrier-methods.component.scss']
})
export class CarrierMethodsComponent {

}
